import React, { FunctionComponent } from 'react';
import Head from 'next/head';
import { Category } from '@wix/answers-api';
import { BasicSeoElements } from '../BasicSEO';
import { LOCALES, PRODUCTION_DOMAIN, SEO } from '../../../constants';
import { PageSeo } from '../../../types';

type CategoryPageProps = {
  category?: Category;
  pageSeo: PageSeo;
};

export const CategoryPageSEO: FunctionComponent<CategoryPageProps> = ({
  category,
  pageSeo,
}) => {
  const fillPlaceholders = (text: string): string =>
    text
      .replace(SEO.PLACEHOLDERS.CATEGORY_TITLE, category?.name || '')
      .replace(SEO.PLACEHOLDERS.COMPANY_NAME, SEO.COMPANY_NAME);

  const description = pageSeo ? fillPlaceholders(pageSeo.description) : '';
  const title = pageSeo ? fillPlaceholders(pageSeo.title) : '';

  return (
    <>
      <BasicSeoElements
        title={title}
        description={description}
        imageUrl={pageSeo?.imageUrl}
        robots={pageSeo?.robots}
      />
      <Head>
        {Object.values(LOCALES)?.map((targetLocale) => (
          <link
            rel="alternate"
            hrefLang={targetLocale}
            href={`https://${PRODUCTION_DOMAIN}/${targetLocale}${category?.uri}`}
            key={`/${targetLocale}${category?.uri}`}
          />
        ))}
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`https://${PRODUCTION_DOMAIN}/${LOCALES.EN}${category?.uri}`}
        />
      </Head>
    </>
  );
};
